<template>
    <div>

        <!-- FILTER START -->
        <log-dash-activity
            :getFilterOnStart="true"
            @filterChange="changeFilter"
        ></log-dash-activity>
        <!-- FILTER END -->

        <!-- FILTER START -->
        <panel class="border border-secondary mt-3" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter Option</h4>
            </template>
            <div class="row outerBox filterBox">
                <div class="col row">
                    <div class="col-md-6 mobileFilterPaddingTop">
                        <label for="partshopCode">Search</label>
                        <input type="text" class="form-control" v-model="filter.search" placeholder="Type username">
                    </div>
                    <div class="col-md-3 offset-md-3 mobileFilterPaddingTop"
                        style="display: flex; flex-direction: column-reverse; padding-top:20px">
                        <button
                            type="button"
                            class="btn btn-primary"
                            style="height:38px; margin-bottom:0.5%"
                            @click="vue_universal_table.update++"
                        >Filter</button>
                    </div>
                </div>
            </div>
        </panel>
        <!-- FILTER END -->

        <div class="bg-white shadow box-content mt-3">
            <vue-universal-table
                api_url="/api/settings/log-dashboard-activity"
                :filter="filter"
                :fields="vue_universal_table.fields"
                :update="vue_universal_table.update"
                :process_data="vue_universal_table.process_data"
                :infinite_scroll="true"

                sort_order="DESC"
                sort_by="id"
            ></vue-universal-table>
        </div>

    </div>
</template>

<script>
    import logDashActivity from '@/components/filter/logDashActivity'
    // import cuUserManagement from './children/CUUserManagement'

    export default {
        metaInfo : {
            title : 'Log Dashboard Activity'
        },
        data () {
            return {
                filter : {
                    search : ''
                },
                filterReady : false,
                vue_universal_table : {
                    fields : [
                        {title:"User ID", variable:"user_id"},
                        {title:"Username", variable:"username"},
                        {title:"Menu", variable:"menu"},
                        {title:"Module", variable:"module"},
                        {title:"Last Access", variable:"created_at"},
                    ],
                    filter : {},
                    update : 0,
                    process_data : `
                        for (var i in data) {
                            data[i].user_id = data[i].user_id ? data[i].user_id : '-'
                            data[i].username = data[i].username ? data[i].username : '-'
                            data[i].menu = data[i].menu ? data[i].menu : '-'
                            data[i].module = data[i].module ? data[i].module : '-'
                            data[i].created_at = data[i].created_at ? data[i].created_at : '-'
                        }
                    `
                },
            }
        },
        components : {
            logDashActivity,
        },
        mounted () {

        },
        methods : {
            changeFilter (filter) {
                for (var i in filter) {
                    this.filter[i] = filter[i];
                    this.vue_universal_table.filter[i] = filter[i];
                }

                //Delete unnecessary filter for the table
                delete this.vue_universal_table.filter.filter;
                // console.log(this.filter);
                this.vue_universal_table.update++;
            },
        }
    }
</script>

<style scoped>
.innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .table td, .table th{
        text-align: center;
    }

    .box-content {
        padding: 20px;
        border-radius: 10px;
    }
</style>